var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOutFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.5003C2.00012 9.14485 2.32436 7.80912 2.94569 6.60451C3.56702 5.3999 4.46742 4.36135 5.57175 3.57549C6.67609 2.78963 7.95235 2.27926 9.29404 2.08696C10.6357 1.89466 12.004 2.026 13.2846 2.47003C14.5652 2.91406 15.7211 3.6579 16.6557 4.63949C17.5904 5.62108 18.2768 6.81196 18.6576 8.11277C19.0384 9.41358 19.1026 10.7866 18.8449 12.1173C18.5872 13.448 18.015 14.6977 17.176 15.7623L20.828 19.4143C21.0102 19.6029 21.111 19.8555 21.1087 20.1177C21.1064 20.3799 21.0012 20.6307 20.8158 20.8161C20.6304 21.0015 20.3796 21.1066 20.1174 21.1089C19.8552 21.1112 19.6026 21.0104 19.414 20.8283L15.762 17.1763C14.5086 18.1642 13.0024 18.7794 11.4157 18.9514C9.82905 19.1233 8.22602 18.8451 6.79009 18.1485C5.35417 17.4519 4.14336 16.3651 3.29623 15.0126C2.44911 13.66 1.99989 12.0962 2 10.5003ZM7 9.50025C6.73478 9.50025 6.48043 9.60561 6.29289 9.79315C6.10536 9.98068 6 10.235 6 10.5003C6 10.7655 6.10536 11.0198 6.29289 11.2074C6.48043 11.3949 6.73478 11.5003 7 11.5003H14C14.2652 11.5003 14.5196 11.3949 14.7071 11.2074C14.8946 11.0198 15 10.7655 15 10.5003C15 10.235 14.8946 9.98068 14.7071 9.79315C14.5196 9.60561 14.2652 9.50025 14 9.50025H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutFill);
export default __webpack_public_path__ + "static/media/zoom-out-fill.ff7350c925a33ca0cba95ccd502d50aa.svg";
export { ForwardRef as ReactComponent };